import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import CustomerUsage from "../UsageFunctions/CustomerUsage";
// import Proposals from '../Proposals/Proposals'
// import { Link } from 'react-router-dom'
import { CopyToClipboard } from "react-copy-to-clipboard";
import Button from "@material-ui/core/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import { auroraApi } from "../../api";
// THis is the main hub on the proposals side. It is what creates the proposals inside...

// import System from '../System/System'
import StateUsage from "../UsageFunctions/StateUsage";
import Usage from "../Usage/Usage";
import Aurora from "../Aurora/Aurora";
import "./Dashboard.css";
import Title from "../Title/Title";
import { UserContext } from "../../UserContext";
import Amplify, { Auth } from "aws-amplify";
import { withAuthenticator } from "@aws-amplify/ui-react";
import AuthGroupWrapper from "../Auth/AuthGroupWrapper";
import HelpButtonMenu from "../HelpButton/HelpButtonMenu";
import proposalToolApi, {
  ProposalToolApi,
} from "../PropView/api/proposal-tool-api";
import { Modal } from "../../shared/components/modal/Modal";
// import moment from 'moment'

const Dashboard = (props) => {
  const { activeUser, setActiveUser } = useContext(UserContext);

  const [customer, setCustomer] = useState([]);
  const [loan, setLoan] = useState([]);
  const [utility, setUtility] = useState("");
  const [utilities, setUtilities] = useState([]);
  const [preUsage, setPreUsage] = useState("");
  const [edit, setEdit] = useState(false);
  const [changeUtility, setChangeUtility] = useState(false);
  const [originalUtility, setOriginalUtility] = useState("");
  const [utilityChanged, setUtilityChanged] = useState(false);
  const [changeJurisdiction, setChangeJurisdiction] = useState(false);
  const [jurisdictions, setJurisdictions] = useState([]);
  const [selectedJurisdiction, setSelectedJurisdiction] = useState("");
  const [jurisdictionLoading, setJurisdictionLoading] = useState(false);
  const [annualUsage, setAnnualUsage] = useState("");
  const [squareFootage, setSquareFootage] = useState("");
  const [team, setTeam] = useState("");
  const [salesTeams, setSalesTeams] = useState([]);
  const [salesTeamName, setSalesTeamName] = useState("");
  const [ppw, setPpw] = useState("");
  const [basePpw, setBasePpw] = useState("");
  const [rebate, setRebate] = useState("");
  const [calculation, setCalculation] = useState("");
  const [hasRebate, setHasRebate] = useState("");
  const [equipment, setEquipment] = useState([]);
  const [stateInfo, setStateInfo] = useState("");
  const [uType, setUType] = useState("");
  const [nvSqFoot, setNvSqFoot] = useState("");
  const [xcelSqFoot, setXcelSqFoot] = useState("");
  const [coreSqFoot, setCoreSqFoot] = useState("");
  const [view, setView] = useState("");
  const [adders, setAdders] = useState([]);
  const [services, setServices] = useState([]);
  const [currentProp, setCurrentProp] = useState("");
  const [loanChangeSize, setLoanChangeSize] = useState("");
  const [loanChangeIncrease, setLoanChangeIncrease] = useState("");
  const [maximumOverDrive, setMaximumOverDrive] = useState("");

  const [panelAmount, setPanelAmount] = useState("");
  const [user, setUser] = useState("");
  const [currentUser, setCurrentUser] = useState("");
  const [loan1, setLoan1] = useState([]);
  const [loan2, setLoan2] = useState([]);
  const [loan3, setLoan3] = useState([]);
  const [utilityLoan1, setUtilityLoan1] = useState([]);
  const [utilityLoan2, setUtilityLoan2] = useState([]);
  const [copied, setCopied] = useState(false);
  const [viewFile, setViewFile] = useState(false);
  const [roofingModalOpen, setRoofingModalOpen] = useState(false);

  const total = (arr) => arr.reduce((a, b) => a + b);

  const apiUrl = proposalToolApi.getUrl();

  const recApiUrl =
    "https://dev.iondeveloper.com/api/proposal/carbon-solutions/carbon-solutions.php";

  async function signOut() {
    try {
      await Auth.signOut();
      await setActiveUser(null);
    } catch (error) {
      console.log("error signing out: ", error);
    }
  }

  const getDesignLink = async () => {
    try {
      const response = await auroraApi.getAdminLink({
        projectId: customer.projectID,
      });
      if (response.success) {
        window.open(response.data, "_blank");
      }
    } catch (error) {
      console.error("Error getting design link:", error);
    }
  };

  useEffect(() => {
    setCurrentUser(
      `${activeUser.attributes.given_name} ${activeUser.attributes.family_name}`,
    );
  }, []);

  let proj_id;

  if (window.location.search) {
    proj_id = window.location.search.slice(9);
  } else {
    // proj_id = 'a00PC000004woF4YAI'
    proj_id = "a00PC00000KIjg5YAD";
  }

  // console.log(window.location.search.slice(9))
  // console.log(props)

  const getCustomer = () => {
    axios
      .post(apiUrl, { method: "get_info", project_id: proj_id })
      .then((res) => {
        const payload = res.data;
        const data = payload?.data;
        if (!data) {
          console.warn("get_info returned no data for project_id:", proj_id, payload);
          return;
        }
        setCustomer(data);
        setUtility(data.utility ?? "");
        setSalesTeamName(data.salesTeam ?? "");
        setPreUsage(payload.usage ?? "");
        setUType(data.usageType ?? "");
        setSquareFootage(data.sqFootage ?? "");
        setAdders(payload.adders ?? []);
        setServices(payload.services ?? []);
        setCurrentProp(payload.proposal ?? "");
        setUser(data.user ?? "");
      })
      .catch((err) => {
        console.error("get_info request failed:", err);
      });
  };

  useEffect(() => {
    if (currentProp && !currentProp.contractSigned) {
      for (let i = 0; i < services.length; i++) {
        adders.push(services[i]);
      }
    }
  }, [services, currentProp.contractSigned]);

  const getMoreInfo = () => {
    if (!utility || utility === "") {
      return;
    }
    console.dir(currentProp);
    axios
      .post(apiUrl, {
        method: "get_more_info_test",
        utility_id: utility,
        salesTeam: customer.salesTeam,
        prop_id: currentProp?.syncPropId,
      })
      .then((res) => {
        // console.log(res.data)
        // console.log(res.data.calc)
        const {
          id1,
          loan1,
          int1,
          dealerfee1,
          term1,
          pre1,
          post1,
          interest1,
          itc1,
          specialPrice1,
          id2,
          loan2,
          int2,
          dealerfee2,
          term2,
          pre2,
          post2,
          interest2,
          itc2,
          specialPrice2,
          id3,
          loan3,
          int3,
          dealerfee3,
          term3,
          pre3,
          post3,
          interest3,
          itc3,
          specialPrice3,
          id4,
          loan4,
          int4,
          dealerfee4,
          term4,
          pre4,
          post4,
          interest4,
          itc4,
          id5,
          loan5,
          int5,
          dealerfee5,
          term5,
          pre5,
          post5,
          interest5,
          itc5,
          hasRebate,
          loanChangeSize,
          loanChangeIncrease,
          loanOptions,
        } = res.data.data;
        return [
          setLoan(res.data.data),
          setPpw(+res.data.data.ppw),
          setBasePpw(+res.data.data.ppw),
          setRebate(res.data.rebate),
          setCalculation(res.data.calc),
          setEquipment(res.data.equipment),
          setStateInfo(res.data.state),
          setHasRebate(hasRebate),
          setLoanChangeSize(+loanChangeSize),
          setLoanChangeIncrease(+loanChangeIncrease),
          setLoan1([
            +id1,
            loan1,
            +term1,
            +int1,
            +pre1,
            +post1,
            +interest1,
            +itc1,
            +specialPrice1,
            ,
            +dealerfee1,
          ]),
          setLoan2([
            +id2,
            loan2,
            +term2,
            +int2,
            +pre2,
            +post2,
            +interest2,
            +itc2,
            +specialPrice2,
            ,
            +dealerfee2,
          ]),
          setLoan3([
            +id3,
            loan3,
            +term3,
            +int3,
            +pre3,
            +post3,
            +interest3,
            +itc3,
            +specialPrice3,
            ,
            +dealerfee3,
          ]),
          setUtilityLoan1([
            +id4,
            loan4,
            +term4,
            +int4,
            +pre4,
            +post4,
            +interest4,
            +itc4,
          ]),
          setUtilityLoan2([
            +id5,
            loan5,
            +term5,
            +int5,
            +pre5,
            +post5,
            +interest5,
            +itc5,
          ]),
        ];
      });
  };

  const provideSalesTeam = () => {
    // if (salesRep !== 'Brandon Thornton') {
    //   for (let i = 0; i <= salesTeams.length; i++) {
    //     if (salesTeams[i] === salesTeam) {
    //       // console.log(salesTeams[i])
    //       return setLoan(team)
    //     }
    //   }
    // }
  };

  const getSalesTeam = () => {
    const teamName = salesTeamName || customer?.salesTeam;
    if (!teamName) return;
    axios
      .post(apiUrl, { method: "get_sales_team", sales_team: teamName })
      .then((res) => {
        // console.log(res.data)
        return setTeam(res.data.data);
      });
  };

  const addSpecialService = () => {
    axios
      .post(apiUrl, { method: "add_special_service", project_id: projectID })
      .then((res) => {
        console.log(res.data);
      });
  };

  const getSalesTeams = () => {
    axios.post(apiUrl, { method: "get_sales_teams" }).then((res) => {
      // console.log(res.data)
      return setSalesTeams(res.data.data);
    });
  };

  const getUtilities = () => {
    axios.post(apiUrl, { method: "get_utilities" }).then((res) => {
      // console.log(res.data)
      return setUtilities(res.data.data);
    });
  };

  const getJurisdictions = () => {
    if (state) {
      axios
        .post(
          `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
          { method: "get_jurisdictions", BillingState: state },
        )
        .then((res) => {
          return setJurisdictions(res.data.data || []);
        });
    }
  };

  const updateJurisdiction = async () => {
    if (!selectedJurisdiction || !customer.designId) return;
    setJurisdictionLoading(true);
    try {
      const usageArray = usage;
      const totalUsage = total(usageArray);

      await auroraApi.updateUsage({
        id: customer.designId,
        id2: projectID,
        Annual_kW_Usage__c: totalUsage,
        January_Usage__c: usageArray[0],
        February_Usage__c: usageArray[1],
        March_Usage__c: usageArray[2],
        April_Usage__c: usageArray[3],
        May_Usage__c: usageArray[4],
        June_Usage__c: usageArray[5],
        July_Usage__c: usageArray[6],
        August_Usage__c: usageArray[7],
        September_Usage__c: usageArray[8],
        October_Usage__c: usageArray[9],
        November_Usage__c: usageArray[10],
        December_Usage__c: usageArray[11],
        Usage_type__c: usageType,
        Square_Footage__c: squareFootage,
        Associated_Jurisdiction__c: selectedJurisdiction,
        user: currentUser,
      });
      getCustomer(); // Refresh customer data
      setChangeJurisdiction(false);
    } catch (error) {
      console.error("Error updating jurisdiction:", error);
    } finally {
      setJurisdictionLoading(false);
    }
  };

  const maxOverDrive = () => {
    if (
      window.confirm(
        "Are you absolutely sure you want to do this? Has this been approved by the appropriate parties?",
      )
    ) {
      return setMaximumOverDrive(1);
    }
    return setMaximumOverDrive(0);
  };

  const {
    january,
    february,
    march,
    april,
    may,
    june,
    july,
    august,
    september,
    october,
    november,
    december,
  } = preUsage;
  let usage = [
    +january,
    +february,
    +march,
    +april,
    +may,
    +june,
    +july,
    +august,
    +september,
    +october,
    +november,
    +december,
  ];

  const {
    name,
    street,
    city,
    zip,
    email,
    salesRep,
    chat,
    setter,
    phone,
    projectID,
    state,
    salesTeam,
    usageType,
    financeId,
    territory,
    jurisdiction,
    jurisdictionOffset,
    designType,
    designLimited,
  } = customer;

  useEffect(() => {
    if (uType === "Square Footage") {
      switch (territory) {
        case "Albuquerque":
          //setAnnualUsage(9503);
          break;
        case "Colorado Springs":
          //setAnnualUsage(9955);
          break;
        case "Las Vegas":
          if (squareFootage >= 4000) {
            //return setAnnualUsage(
            //  Math.round(2392.4 * Math.pow(+squareFootage, 0.25)),
            //);
          } else if (squareFootage < 4000 && squareFootage > 1000) {
            //return setAnnualUsage(Math.round(4.286 * +squareFootage + 1882));
          } else if (squareFootage <= 1000) {
            //return setAnnualUsage(
            //  Math.round(195.05 * Math.pow(+squareFootage, 0.5)),
            //);
          }
          // setAnnualUsage(12771)
          break;
        case "Buda":
          //setAnnualUsage(12479);
          break;
        case "Denver":
          //setAnnualUsage(10413);
          break;
        case "Dallas":
          //setAnnualUsage(12236);
          break;
        case "Utah":
          //setAnnualUsage(10639);
          break;
        case "Oregon":
          //setAnnualUsage(9687);
          break;
        case "North Carolina":
          //setAnnualUsage(13100);
          break;
        case "South Carolina":
          //setAnnualUsage(13100);
          break;
        case "Richmond":
          //setAnnualUsage(16126);
          break;
        case "Virginia Beach":
          //setAnnualUsage(15052);
          break;
        default:
          //setAnnualUsage(12475);
      }
    }
  }, [customer, uType, squareFootage, territory]);

  // console.log(annualUsage)

  useEffect(() => {
    setNvSqFoot(
      Math.floor(
        (+squareFootage * 2.8) / (equipment.modPtcRating * equipment.invRating),
      ),
    );
  }, [equipment, squareFootage]);

  useEffect(() => {
    if (squareFootage >= 4001) {
      return setXcelSqFoot(24910);
    } else if (squareFootage >= 3501 && squareFootage <= 4000) {
      return setXcelSqFoot(21814);
    } else if (squareFootage >= 3001 && squareFootage <= 3500) {
      return setXcelSqFoot(20000);
    } else if (squareFootage >= 2501 && squareFootage <= 3000) {
      return setXcelSqFoot(18184);
    } else if (squareFootage >= 2001 && squareFootage <= 2500) {
      return setXcelSqFoot(16866);
    } else if (squareFootage >= 1501 && squareFootage <= 2000) {
      return setXcelSqFoot(14666);
    } else if (squareFootage >= 1001 && squareFootage <= 1500) {
      return setXcelSqFoot(12142);
    } else if (squareFootage >= 501 && squareFootage <= 1000) {
      return setXcelSqFoot(9096);
    } else if (squareFootage < 500) {
      return setXcelSqFoot(6398);
    }
  }, [equipment, squareFootage]);

  useEffect(() => {
    setCoreSqFoot(squareFootage * 3 * 2);
  }, [equipment, squareFootage]);

  // console.log(coreSqFoot)

  useEffect(() => {
    if (uType === "Annual" || uType === "Annual - Square Footage") {
      setAnnualUsage(customer.usage);
    }
  }, [customer, uType]);

  useEffect(() => {
    getUtilities();
  }, []);

  useEffect(() => {
    getJurisdictions();
  }, [state]);

  useEffect(() => {
    getSalesTeams();
  }, []);

  useEffect(() => {
    if (utility && utility !== "") {
      getMoreInfo();
    }
  }, [utility]);

  useEffect(() => {
    if (salesTeamName || customer?.salesTeam) {
      getSalesTeam();
    }
  }, [customer]);

  useEffect(() => {
    if (proj_id) {
      getCustomer();
    }
  }, []);

  let stateUtilities = [];

  if (rebate) {
    for (let i = 0; i < utilities.length; i++) {
      if (utilities[i].utilityLocation === rebate.utilityLocation) {
        stateUtilities.push(utilities[i]);
      }
    }
  }

  let mappedUtilities = stateUtilities.map((utilities, i) => {
    return (
      <option key={i} value={utilities.utility}>
        {utilities.utility}
      </option>
    );
  });

  const adderToggle = (num, operation) => {
    if (num === 1 || num === 2) {
      return operation(0);
    }
    operation(1);
  };

  useEffect(() => {
    if (team.has_team_ppw === "1") {
      if (utility === "Austin Energy") {
        return setPpw(ppw);
      }
      if (utility === "City Public Service (CPS)") {
        return setPpw(ppw);
      }
      setBasePpw(team.ppw);
      setPpw(team.ppw);
    }
  }, [edit, utility, customer]);

  let newUsage = StateUsage(state, usage, annualUsage, usageType);

  if (newUsage) {
    usage = newUsage;
  }

  const repInfo = () => {
    if (salesRep === "Ivan Varela") {
      return (
        <span style={{ color: "rgba(232, 54, 54, 0.82)" }}>
          Sales Rep is Ivan Varela<br></br> Please build to only 70% offset.
        </span>
      );
    }
    if (salesRep === "Brandon Borkoski") {
      return (
        <span style={{ color: "rgba(232, 54, 54, 0.82)" }}>
          Sales Rep is Brandon Borkoski<br></br> If system size is greater than
          6kW, he wants 80-85% offset.
        </span>
      );
    }
    if (salesTeam === "Austin Sales Team 2") {
      return (
        <span style={{ color: "rgba(232, 54, 54, 0.82)" }}>
          Sales Team is Austin 2<br></br> Please build to 80-85% offset.
        </span>
      );
    }
    if (utility === "PNM - Public Service Company of New Mexico") {
      return (
        <CopyToClipboard onCopy={() => setCopied(true)} text={customer.street}>
          <a
            target="_blank"
            href="https://pnm.maps.arcgis.com/apps/webappviewer/index.html?id=cbd3bad85fc64f2180dda652e957bacd"
          >
            <Button
              size="large"
              style={{ color: "rgba(232, 54, 54, 0.82)", fontSize: "1.5rem" }}
            >
              Please click here to make sure there is feeder capacity, if not,
              don't build the proposal{" "}
            </Button>
          </a>
        </CopyToClipboard>
      );
    }
    if (utility === "Rocky Mountain Power") {
      return (
        <span style={{ color: "rgba(232, 54, 54, 0.82)" }}>
          Utility is {utility}
          <br></br> Please build as close to 90% offset.
        </span>
      );
    }
    if (utility === "Fort Collins Utilities (FCU)") {
      return (
        <span style={{ color: "rgba(232, 54, 54, 0.82)" }}>
          Utility is {utility}
          <br></br> Do Not Use East Facing Roof Sections
        </span>
      );
    }
    if (utility === "Salt River Project (SRP)") {
      return (
        <span style={{ color: "rgba(232, 54, 54, 0.82)" }}>
          Utility is {utility}
          <br></br> Build to 60%, Do not use East Facing Roof Sections, Must be
          {">"} 4 kW
        </span>
      );
    }
    if (utility === "Arizona Public Service Company (APS)") {
      return (
        <span style={{ color: "rgba(232, 54, 54, 0.82)" }}>
          Utility is {utility}
          <br></br> Build to 120%
        </span>
      );
    }

    return <></>;
  };

  let color = "rgb(7, 95, 114)";

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
        crossOrigin="anonymous"
      />
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css"
      />
      <AuthGroupWrapper requiredGroups={["Proposals", "Ops", "Sales-Support"]}>
        <Title title={`${name} Proposalist`} />
        <nav className="navbar navbar-expand-md navbar-dark bg-dark mb-4">
          <div className="container">
            <h1 style={{ fontSize: "3em", color: "#fff" }}>proposalist.</h1>
            <ul className="navbar-nav ms-auto pr-5">
              <li style={{ color: "#fff" }}>
                {currentUser} |{" "}
                <button
                  style={{ borderRadius: "5px" }}
                  onClick={() => signOut()}
                >
                  Sign Out
                </button>
              </li>
            </ul>
          </div>
        </nav>
        <main role="main">
          <section>
            <div className="jumbotron mb-5 mt-5">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <h2 className="mb-0">{name}</h2>
                    <p className="fs-5 text-muted">
                      {street} {city}, {state} {zip}
                    </p>
                    <p>
                      <b>Email:</b> {email}
                      <br></br>
                      <b>Phone:</b> {phone}
                    </p>
                    <p>
                      <b>Notes:</b> {chat}
                    </p>

                    {viewFile ? (
                      <>
                        <Modal
                          isOpen={viewFile}
                          onClose={() => setViewFile(false)}
                          title="File Browser"
                          showCloseButton={true}
                          closeOnOverlayClick={true}
                        >
                          <div className="wrap">
                            <iframe
                              src={`https://app.iondeveloper.com/s3-file-browser/view.php?proj_id=${proj_id}&s=a00-project__c&n=${currentUser}`}
                              height="800"
                              width="100%"
                              style={{ border: "none" }}
                            ></iframe>
                          </div>
                        </Modal>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => adderToggle(viewFile, setViewFile)}
                        >
                          File Browser
                        </button>
                        {customer.solarGrafProjectId &&
                        customer.solarGrafDesignId ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm ms-2"
                            onClick={getDesignLink}
                          >
                            Open Aurora
                          </button>
                        ) : null}
                        <button
                          type="button"
                          className="btn btn-primary btn-sm ms-2"
                          onClick={() =>
                            window.open(
                              `https://ionsolar.lightning.force.com/lightning/r/Project__c/${proj_id}/view`,
                              "_blank",
                            )
                          }
                        >
                          Open Salesforce
                        </button>
                      </>
                    )}
                  </div>
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-header pt-3">
                        <h4>Project Information </h4>
                      </div>
                      <div className="card-body">
                        <ul className="list-group list-group-flush">
                          <li className="list-group-item">
                            <b>Sales Rep: </b>
                            {salesRep}
                            <br></br>
                            <span className="text-muted">{salesTeam}</span>
                          </li>
                          <li className="list-group-item">
                            <b>Setter: </b>
                            {setter}
                          </li>
                          <li className="list-group-item">
                            <b>Utility: </b>
                            {utility}
                            <button
                              className="rounded ms-2"
                              onClick={() => {
                                setOriginalUtility(utility);
                                setUtilityChanged(false);
                                setChangeUtility(true);
                              }}
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                            <Modal
                              isOpen={changeUtility}
                              onClose={() => {
                                setChangeUtility(false);
                                setUtilityChanged(false);
                                setOriginalUtility("");
                              }}
                              title="Change Utility"
                              className="small"
                              footer={
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                      setChangeUtility(false);
                                      setUtilityChanged(false);
                                      setOriginalUtility("");
                                    }}
                                  >
                                    Close
                                  </button>
                                </>
                              }
                            >
                              <div className="mb-3">
                                <label className="form-label">
                                  Select Utility
                                </label>
                                <select
                                  className="form-select"
                                  onChange={(e) => {
                                    setUtility(e.target.value);
                                    setUtilityChanged(
                                      e.target.value !== originalUtility,
                                    );
                                  }}
                                >
                                  <option>{utility}</option>
                                  {mappedUtilities}
                                </select>
                              </div>
                              {utilityChanged && (
                                <div
                                  className="alert alert-info mt-3"
                                  role="alert"
                                >
                                  The utility has been updated in Proposalist
                                  and SalesForce but you will need to manually
                                  update it in Aurora as well.{" "}
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      getDesignLink();
                                    }}
                                    style={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Open Aurora
                                  </a>
                                </div>
                              )}
                            </Modal>
                          </li>
                          <li className="list-group-item">
                            <b>Jurisdiction: </b>
                            {jurisdiction}
                            <button
                              className="rounded ms-2"
                              onClick={() => {
                                // Find the jurisdiction ID from the name
                                const currentJur = jurisdictions.find(
                                  (jur) => jur.name === jurisdiction,
                                );
                                setSelectedJurisdiction(currentJur?.id || "");
                                setChangeJurisdiction(true);
                              }}
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                            <Modal
                              isOpen={changeJurisdiction}
                              onClose={() => setChangeJurisdiction(false)}
                              title="Jurisdiction Information"
                              className="medium"
                              footer={
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div style={{ display: "flex", gap: "8px" }}>
                                    <button
                                      type="button"
                                      className="btn btn-info text-white"
                                      onClick={() =>
                                        window.open(
                                          "https://ahjregistry.myorangebutton.com/#/ahj-search",
                                          "_blank",
                                          "noopener,noreferrer",
                                        )
                                      }
                                    >
                                      AHJ Registry
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-info text-white"
                                      onClick={() =>
                                        window.open(
                                          "https://www.melissa.com/v2/lookups/addresscheck/address/",
                                          "_blank",
                                          "noopener,noreferrer",
                                        )
                                      }
                                    >
                                      Melissa
                                    </button>
                                    {state === "Colorado" ? (
                                      <button
                                        type="button"
                                        className="btn btn-info text-white"
                                        onClick={() =>
                                          window.open(
                                            "https://colorado.hometownlocator.com/maps/",
                                            "_blank",
                                            "noopener,noreferrer",
                                          )
                                        }
                                      >
                                        Colorado AHJ
                                      </button>
                                    ) : null}
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={jurisdictionLoading}
                                    onClick={() => updateJurisdiction()}
                                  >
                                    {jurisdictionLoading ? (
                                      <CircularProgress
                                        size={20}
                                        color="inherit"
                                      />
                                    ) : (
                                      "Save"
                                    )}
                                  </button>
                                </div>
                              }
                            >
                              <div className="mb-3">
                                {(() => {
                                  let zipNote;
                                  if (+zip === 22401) {
                                    zipNote = `Fredericksburg, VA`;
                                  }
                                  if (+zip === 22407 || +zip === 22408) {
                                    zipNote = `Spotsylvania County, VA`;
                                  }
                                  if (+zip === 22405 || +zip === 22406) {
                                    zipNote = `Stafford County, VA`;
                                  }
                                  return zipNote ? (
                                    <div className="mb-3">
                                      <span
                                        style={{
                                          color: "rgba(232, 54, 54, 0.82)",
                                        }}
                                      >
                                        Zip code is {zip} - Associated
                                        Jurisdiction is {zipNote}
                                      </span>
                                    </div>
                                  ) : null;
                                })()}
                                <Autocomplete
                                  disableClearable
                                  id="jurisdiction-autocomplete"
                                  options={jurisdictions}
                                  getOptionSelected={(option, value) =>
                                    option.id === value.id
                                  }
                                  getOptionLabel={(option) => `${option.name}`}
                                  value={
                                    jurisdictions.find(
                                      (jur) => jur.id === selectedJurisdiction,
                                    ) || null
                                  }
                                  onChange={(event, value) =>
                                    setSelectedJurisdiction(value?.id || "")
                                  }
                                  style={{ width: "100%" }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      size="small"
                                      label=""
                                      margin="dense"
                                      fullWidth
                                    />
                                  )}
                                />
                              </div>
                            </Modal>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            name="usageHeader"
            style={{ backgroundColor: "#ededed", paddingTop: "50px" }}
          >
            {utility ? (
              <>
                <Usage
                  customer={customer}
                  salesTeam={customer.salesTeam}
                  currentUser={currentUser}
                  maximumOverDrive={maximumOverDrive}
                  designId={customer.designId}
                  preUsage={preUsage}
                  squareFootage={squareFootage}
                  custUsage={customer.usage}
                  zip={zip}
                  getCustomer={getCustomer}
                  newUsage={newUsage}
                  state={state}
                  calculation={calculation}
                  utility={utility}
                  territory={territory}
                  projectID={projectID}
                  hasJurisdiction={jurisdiction}
                  jurisdictions={jurisdictions}
                  onOpenRoofingModal={() => setRoofingModalOpen(true)}
                />
              </>
            ) : (
              <>
                <div className="filler"></div>
                <div className="filler"></div>
                <div className="filler"></div>
              </>
            )}
          </section>

          <CustomerUsage
            customer={customer}
            jurisdiction={jurisdiction}
            city={customer.city}
            salesRep={salesRep}
            setMaximumOverDrive={setMaximumOverDrive}
            maximumOverDrive={maximumOverDrive}
            maxOverDrive={maxOverDrive}
            team={team}
            loan1={loan1}
            loan2={loan2}
            loan3={loan3}
            utilityLoan1={utilityLoan1}
            utilityLoan2={utilityLoan2}
            loanChangeSize={loanChangeSize}
            loanChangeIncrease={loanChangeIncrease}
            setUtility={setUtility}
            repInfo={repInfo}
            getCustomer={getCustomer}
            currentProp={currentProp}
            adders={adders}
            projectID={projectID}
            financeId={financeId}
            utility={utility}
            usage={usage}
            edit={edit}
            setEdit={setEdit}
            view={view}
            setView={setView}
            loan={loan}
            equipment={equipment}
            stateInfo={stateInfo}
            setter={customer.setter}
            salesTeam={customer.salesTeam}
            step={customer.step}
            ppw={ppw}
            basePpw={basePpw}
            rebate={rebate}
            calculation={calculation}
            hasRebate={hasRebate}
            usageType={usageType}
            name={customer.name}
            provideSalesTeam={provideSalesTeam}
            nvSqFoot={nvSqFoot}
            setNvSqFoot={setNvSqFoot}
            squareFootage={squareFootage}
            xcelSqFoot={xcelSqFoot}
            coreSqFoot={coreSqFoot}
            panelAmount={panelAmount}
            designId={customer.designId}
            chat={chat}
            newUsage={newUsage}
            preUsage={preUsage}
            oppId={customer.oppId}
            surveyType={customer.surveyType}
            stories={customer.stories}
            designType={designType}
            limitedSpace={designLimited}
            roofingModalOpen={roofingModalOpen}
            setRoofingModalOpen={setRoofingModalOpen}
          />
        </main>
        <HelpButtonMenu />
      </AuthGroupWrapper>
    </>
  );
};

export default Dashboard;
